// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import ImageCard from './data'

export default function ImageCardFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/ImageCard">
      <ImageCard {...props}>
        {children}
      </ImageCard>
    </Flow>
  )
}
